import React, { Component } from 'react'
import { PieChart } from 'react-minimal-pie-chart';

class PieChartPractice extends Component {
    state = {
        
    }
    render() {
        return (
            <div>

                 <PieChart
                    data={[
                        { title: 'One', value: 10, color: 'white' },
                        { title: 'Two', value: 15, color: '#C13C37' },
                        { title: 'Three', value: 20, color: '#6A2135' },
                    ]}
                />; 



            </div>
        )
    }
}

export default PieChartPractice
